export var buildEnv = {
    buildMode: 'release',
    sdkVersion: '4.1.0',
};
//# sourceMappingURL=buildEnv.js.map